module.exports = __webpack_public_path__ + "static/media/eye-icon.9d819554.svg";